<template>
  <div class="molecule-benefit-list">
    <div class="vision-cards">
      <FeatureCard
        v-for="(item, index) in items"
        :key="index"
        icon="check-circle"
        :icon-size="32"
        icon-color="#16a34a"
        :icon-stroke-width="2"
        :title="item.title"
        :description="item.description"
      />
    </div>
  </div>
</template>

<script>
import FeatureCard from "@/components/molecules/FeatureCard.vue";

export default {
  name: "BenefitList",
  components: {
    FeatureCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every(
          (item) =>
            typeof item === "object" &&
            item !== null &&
            typeof item.title === "string" &&
            typeof item.description === "string"
        ),
    },
  },
};
</script>

<style scoped>
.molecule-benefit-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.vision-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3rem;
  margin-top: 4rem;
  width: 100%;
}

@media (max-width: 768px) {
  .molecule-benefit-list {
    gap: 1.5rem;
  }

  .vision-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 2rem;
  }
}
</style>
